import { action, observable } from 'mobx';
import { DEFAULT_LOCALE, setLocale } from '@triplabo/web/i18n';

export class App {
  @observable accessor loading = false;

  @observable accessor locale: string = DEFAULT_LOCALE;

  @action
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  @action
  changeLocale(locale: string) {
    this.locale = setLocale(locale);
  }
}

const app = new App();

export default app;
